module.exports = "/_next/static/images/payments_header-39f756a052eb01b9cc67b7289533d045.png";